import React from "react";
import { Modal } from "reactstrap";
import { toast } from "react-toastify";
import { enableTag, getTags } from "../../../../helpers/service";
import { useSelector } from "react-redux";
import { useFormik } from "formik";
import * as yup from "yup";
import Textfield from "../../../Shared/Textfield";
import Button from "../../../Shared/Button";
import styles from "./EnableDisable.module.scss";

const handleSubmitValidation = yup.object().shape({
  tagIds: yup.string().required("Tag IDs are required"),
});

const EnableDisable = ({ openModal, toggle, setLoading }) => {
  const userData = useSelector((state) => state.authReducer);

  // Define handleSubmit outside of useFormik
  const handleSubmit = async (values, { resetForm }) => {
    try {
      const data = {
        tagIds: values.tagIds.split(",").map((id) => id.trim()),
        isEnabled: values.isEnabled === "true",
      };

      setLoading(true);

      const tagData = await enableTag(data, userData.idToken);

      if (tagData?.data) {
        await getTags(userData.idToken);
      }

      toast.success("Tag status updated successfully");
      resetForm();
      toggle();
    } catch (error) {
      console.error("Error enabling/disabling tags:", error);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const formik = useFormik({
    initialValues: { tagIds: "" },
    validationSchema: handleSubmitValidation,
    onSubmit: handleSubmit,
  });

  return (
    <Modal
      isOpen={openModal}
      toggle={toggle}
      centered
      fullscreen="sm"
      contentClassName={styles.modal_content}
      className={styles.container}
      wrapClassName={styles.modal_wrapper}
    >
      <div className={styles.managetags_modal_container}>
        <p className={styles.header_text}>Enable/Disable Tags</p>
        <p className={styles.label_text}>
          Disable tags for products that have been lost, destroyed, or stolen.
          Disabled tags will still scan in the LRX app, but will show a warning
          to users. Click Enable to restore tags that have been disabled. All
          tags are enabled by default.
        </p>
        <p className={styles.label_text} style={{ marginBottom: "15px" }}>
          Enter the first and last Unique Identification (UID) numbers for the
          NFC tags you'd like to change. You can find the UID of a tag by
          scanning it in the LRX app.
        </p>
        <Textfield
          placeholder="Tag Ids (comma separated)"
          className={styles.input_field_container}
          name="tagIds"
          id="tagIds"
          onChange={formik.handleChange}
          value={formik.values.tagIds}
          error={formik.errors.tagIds}
          touched={formik.touched.tagIds}
        />
        <p className={styles.label_footer_text}>
          When you click Disable/Enable, we'll apply that action to both NFC
          tags and every tag in between them on the same roll.
        </p>
        <div className={styles.button_container}>
          <Button
            className={styles.button_enable_cancel}
            onClick={() => {
              formik.setFieldValue("isEnabled", "false");
              formik.submitForm();
            }}
            text="Disable"
          />
          <Button
            className={styles.button_enable_enable}
            onClick={() => {
              formik.setFieldValue("isEnabled", "true");
              formik.submitForm();
            }}
            text="Enable"
          />
        </div>
      </div>
    </Modal>
  );
};

export default EnableDisable;
